// extracted by mini-css-extract-plugin
module.exports = {"home-hero-title":"styles_home-hero-title__3VOBt","home-hero-copy":"styles_home-hero-copy__29Adr"};